export default __webpack_public_path__ + "static/media/folder-orange.56c04c5c.svg";